<div class="daily-standup-details">
  @if (!dailyData()) {
    <p class="no-data">No hay datos disponibles</p>
  } @else {
    <div class="details-content">
      <div class="summary-grid">
        <div class="summary-item" matTooltip="Las que han sido programadas en el periodo" matTooltipPosition="above">
          <span class="summary-label">Programadas</span>
          <span class="summary-value">{{ dailyData()!.dailies_scheduled }}</span>
        </div>
        <div
          class="summary-item"
          matTooltip="Las programadas que ya han pasado y que contabilizan para el cálculo del kpi"
          matTooltipPosition="above"
        >
          <span class="summary-label">Aplicables</span>
          <span class="summary-value">{{ dailyData()!.dailies_requiring_attendance }}</span>
        </div>
        <div class="summary-item" matTooltip="Las que se han realizado 🤡" matTooltipPosition="above">
          <span class="summary-label">Realizadas</span>
          <span class="summary-value text-good">{{ dailyData()!.dailies_with_registered_attendance }}</span>
        </div>
        <div class="summary-item" matTooltip="Las que no se han realizado 🤡" matTooltipPosition="above">
          <span class="summary-label">No realizadas</span>
          <span class="summary-value text-warn">{{ dailyData()!.missing_daily_dates.length }}</span>
        </div>
      </div>

      <div class="dates-section">
        <h5 class="section-title">Dailies realizadas</h5>
        @if (dailyData()!.completed_daily_dates.length === 0) {
          <p class="no-data small">No hay dailies realizadas en el periodo.</p>
        } @else {
          <div class="date-chips">
            @for (date of dailyData()!.completed_daily_dates; track $index) {
              <span class="date-chip done">{{ date | date: 'dd/MM/yyyy' }}</span>
            }
          </div>
        }
      </div>

      <div class="dates-section">
        <h5 class="section-title">Dailies no realizadas</h5>
        @if (dailyData()!.missing_daily_dates.length === 0) {
          @if (dailyData()!.completed_daily_dates.length === 0) {
            <p class="no-data small">No hay dailies realizadas en el periodo.</p>
          } @else {
            <p class="no-data small">¡Bien! Se han realizado todas las dailies aplicables.</p>
          }
        } @else {
          <div class="date-chips">
            @for (date of dailyData()!.missing_daily_dates; track $index) {
              <span class="date-chip missing">{{ date | date: 'dd/MM/yyyy' }}</span>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
